export const DEFAULT_CONTENT_KEY = 'checkout.defaultContent';
export const CHECKOUT_JOURNEY_ID = 'online-shop/checkout';
export const SERVICE_PLAN_DATA_LAYER_CATEGORY = 'ServicePlan';
export const SERVICE_ADD_ON_DATA_LAYER_CATEGORY = 'ServiceAddOn';
export const CREDIT_CHECK_SECTION_ID = 'creditCheck';

export const DEFAULT_CONTENT = {
  [DEFAULT_CONTENT_KEY]: {
    value: '',
    url: '',
  },
};

export const GIFT_CARD_TOTAL_AMOUNT = 'GIFT_CARD_TOTAL_AMOUNT';

export const GIFT_CARD_ERROR_MESSAGE =
  "The gift card number or PIN you've entered is invalid. Please check them again.";

export const GIFT_CARD_EXPIRY_MESSAGE = 'Sorry, your gift card has expired.';

export const GIFT_CARD_ZERO_BALANCE_ERROR_MESSAGE =
  'There is no remaining balance on this gift card.';

export const DEFAULT_ERROR_MESSAGE = 'Something unexpected occurred';

const PASSPORT_ERROR_MESSAGE =
  'Your passport info might be wrong. Make sure that your name, date of birth and passport information are the same as on your passport. Check and re-enter your details or try using your drivers license instead.';

const DRIVER_LICENCE_ERROR_MESSAGE =
  'Your personal details need to match your driver licence details. Please check that your name and licence information has been entered correctly.';

export const ERROR_MESSAGE_RECORD: Record<string, string> = {
  '5501': PASSPORT_ERROR_MESSAGE,
  '5502': PASSPORT_ERROR_MESSAGE,
  '5503': DRIVER_LICENCE_ERROR_MESSAGE,
  '5504': DRIVER_LICENCE_ERROR_MESSAGE,
  '5511': GIFT_CARD_ERROR_MESSAGE,
  '5512': GIFT_CARD_ERROR_MESSAGE,
  '4242': GIFT_CARD_ERROR_MESSAGE,
  '4245': GIFT_CARD_ZERO_BALANCE_ERROR_MESSAGE,
  '4246': GIFT_CARD_EXPIRY_MESSAGE,
  '4152': GIFT_CARD_ERROR_MESSAGE,
};

export const STEP_ERROR_MESSAGE_ID = 'STEP_ERROR_MESSAGE';
